var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6099 2.15797L6.85988 6.65728C6.61866 6.88575 6.3091 7 6 7C5.69091 7 5.38134 6.88575 5.14013 6.65728L0.390151 2.15797C-0.110819 1.68344 -0.132288 0.89253 0.342807 0.391624C0.817401 -0.110251 1.6089 -0.13172 2.10987 0.34378L6 4.02878L9.89013 0.34378C10.3906 -0.132688 11.1821 -0.11122 11.6572 0.391624C12.1323 0.89253 12.1108 1.68344 11.6099 2.15797Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.86c3cb140d06a87ccbdd278611f925cc.svg";
export { ForwardRef as ReactComponent };